import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { CandidatePoolTag } from '../candidate-pool-tag/candidate-pool-tag.interface';
import { CandidatePool } from './candidate-pool.interface';
import candidatePoolService from './candidate-pool.service';

export interface CandidatePoolState {
   candidate_pools: Array<CandidatePool>;
}

const CandidatePoolStore: Module<CandidatePoolState, StoreState> = {
   namespaced: true,
   state: {
      candidate_pools: [],
   },

   getters: {},

   mutations: {
      candidatePoolsActivated(state, { candidate_pool_ids }: { candidate_pool_ids: Array<number> }) {
         state.candidate_pools
            .filter((candidate_pool) => candidate_pool_ids.includes(candidate_pool.id))
            .map((candidate_pool) => (candidate_pool.candidate!.activation_state_key = 'activation-in-queue'));
      },
      UPDATE_CANDIDATE_POOL(
         state,
         {
            candidate_pool_id,
            candidate_pool,
            key,
            value,
         }: { candidate_pool_id: number; candidate_pool: CandidatePool; key: string; value: any },
      ) {
         const INDEX_OF_CANDIDATE_POOL = state.candidate_pools.findIndex(
            (state_candidate_pool) => state_candidate_pool.id === candidate_pool_id,
         );

         if (key && value) {
            state.candidate_pools[INDEX_OF_CANDIDATE_POOL][key] = value;
            return;
         }

         state.candidate_pools[INDEX_OF_CANDIDATE_POOL] = candidate_pool;
      },
      UPDATE_CANDIDATE_POOLS(state, { candidate_pools }: { candidate_pools: Array<CandidatePool> }) {
         candidate_pools.forEach((candidate_pool) => {
            const INDEX_OF_CANDIDATE_POOL = state.candidate_pools.findIndex((cp) => cp.id == candidate_pool.id);
            if (INDEX_OF_CANDIDATE_POOL < 0) return;
            state.candidate_pools[INDEX_OF_CANDIDATE_POOL] = { ...state.candidate_pools[INDEX_OF_CANDIDATE_POOL], ...candidate_pool };
         });
      },
      addTagToCandidatePool(
         state,
         {
            key = 'tags',
            candidate_pool_id,
            candidate_pool_tag,
         }: { key: string; candidate_pool_id: number; candidate_pool_tag: CandidatePoolTag },
      ) {
         const CANDIDATE_INDEX = state.candidate_pools.findIndex((c) => c.id === candidate_pool_id);
         if (CANDIDATE_INDEX < 0) return;

         state.candidate_pools[CANDIDATE_INDEX][key].push(candidate_pool_tag);
      },
      removeCandidateTagFromPool(state, { key, candidate_pool_tag }: { key: string; candidate_pool_tag: CandidatePoolTag }) {
         if (!candidate_pool_tag?.candidate_pool_id) return;

         const INDEX_OF_CP = state.candidate_pools.findIndex(
            (candidate_pool) => candidate_pool.id === candidate_pool_tag.candidate_pool_id,
         );
         if (INDEX_OF_CP < 0) return;

         state.candidate_pools[INDEX_OF_CP][key] = state.candidate_pools[INDEX_OF_CP][key].filter(
            (tag) => tag.id !== candidate_pool_tag.tag_id,
         );
      },
   },

   actions: {
      async postBulk(context, { candidate_ids, pool_ids }: { candidate_ids: Array<number>; pool_ids: Array<number> }) {
         const BODY = { candidate_ids, pool_ids } as Partial<CandidatePool>;
         return await candidatePoolService.postBulk(BODY).then((response) => {
            return response;
         });
      },
   },
};

export default CandidatePoolStore;
